import { OptionsCell } from '@/components/Table';
import { MenuOption } from '@/components/DefaultOptionsMenu';
import DeleteCompanyInvestorDialog from '@/dialogs/DeleteCompanyInvestorDialog';
import EditCompanyInvestorDialog from '@/dialogs/EditCompanyInvestorDialog';
import { AddIcon } from '@/icons';
import { useToggle } from '@/hooks/useToggle';

export type CompanyInvestorOptionsCellProps = {
  companyId: number;
  investorId: number;
  onAddNew: () => void;
};

export default function CompanyInvestorOptionsCell({
  companyId,
  investorId,
  onAddNew,
}: CompanyInvestorOptionsCellProps) {
  const [isEditDialogOpen, toggleEditDialog] = useToggle(false);
  const [isRemoveDialogOpen, toggleRemoveDialog] = useToggle(false);

  const handleAddNew = (onClose: () => void) => {
    onAddNew();
    onClose();
  };

  return (
    <>
      {isEditDialogOpen && (
        <EditCompanyInvestorDialog
          companyId={companyId}
          investorId={investorId}
          onClose={() => toggleEditDialog(false)}
        />
      )}
      {isRemoveDialogOpen && (
        <DeleteCompanyInvestorDialog
          companyId={companyId}
          investorId={investorId}
          onClose={() => toggleRemoveDialog(false)}
        />
      )}
      <OptionsCell
        renderExtraOptions={(onClose) => [
          <MenuOption
            key="new"
            label="New"
            icon={<AddIcon />}
            onClick={() => handleAddNew(onClose)}
          />,
        ]}
        onEdit={() => toggleEditDialog()}
        onDelete={() => toggleRemoveDialog()}
      />
    </>
  );
}
